import SportOfferSubNav from './sportOffer/SportOfferSubNav.vue';
import FavouritesSubNav from './sportOffer/FavouritesSubNav.vue';
import LottoSubNav from './lotto/LottoSubNav.vue';
import ResultsSubNav from './results/ResultsSubNav.vue';
import SportsNav from './components/SportNav.vue';
import SpecialsSubNav from './specials/SpecialsSubNav.vue';
import AccountSubNav from './account/AccountSubNav.vue';
import ShopsSubNav from './shops/ShopsSubNav.vue';
import VirtualGamesSubNav from './virtualGames/VirtualGamesSubNav.vue';
import NewsSubNav from './news/NewsSubNav.vue';
import GamesSubNav from './games/GamesSubNav.vue';
import GenericSubNav from './general/GenericSubNav.vue';

export {
    SportOfferSubNav,
    FavouritesSubNav,
    LottoSubNav,
    ResultsSubNav,
    SportsNav,
    SpecialsSubNav,
    AccountSubNav,
    ShopsSubNav,
    VirtualGamesSubNav,
    NewsSubNav,
    GamesSubNav,
    GenericSubNav,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/mobile/subnavs.ts